import styled from "@emotion/styled";

export const MDSPanelHeaderButtonGroup = styled.div<{ orientation?: "horizontal" | "vertical" }>`
  display: flex;
  flex-direction: ${({ orientation = "horizontal" }) =>
    orientation === "horizontal" ? "row" : "column"};
`;
